export const anchorConfig = {
    name: 'Anchor',
    image: 'https://cdn.zappy.app/c8e9252849d606dd84861bc9212b5a58.png',
    inputs: [
        {
            name: 'anchorID',
            type: 'string',
            required: true,
        },
    ],
    category: 'Zapier Utilities',
};
//# sourceMappingURL=config.js.map